import { Button } from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { ReactElement, useState } from "react";

import {
  CancelCampaignInitialSendMutation,
  CancelCampaignInitialSendMutationVariables,
} from "~frontend/__generated__/graphql";
import { CANCEL_CAMPAIGN_INITIAL_SEND } from "~frontend/graphql/campaigns";
import theme from "~frontend/theme";
import useMutation from "~frontend/util/useMutation";

import { CampaignForView } from "../types";
import RoiTestSummary from "./RoiTestSummary";

export default function InitialSendScheduled({
  campaign,
}: {
  campaign: CampaignForView;
}): ReactElement {
  const [cancelInitialSend] = useMutation<
    CancelCampaignInitialSendMutation,
    CancelCampaignInitialSendMutationVariables
  >(CANCEL_CAMPAIGN_INITIAL_SEND, {
    onErrorSnackbarMessage: "Failed to cancel initial send",
    variables: {
      input: {
        campaignId: campaign.id,
      },
    },
  });

  const [submittingCancel, setSubmittingCancel] = useState(false);
  const confirm = useConfirm();

  async function handleCancel() {
    if (submittingCancel) {
      return;
    }

    const { confirmed } = await confirm({
      title: "Cancel Send",
      description: "Are you sure you want to cancel the send?",
      confirmationText: "Cancel Send",
      cancellationText: "No",
    });
    if (!confirmed) {
      return;
    }

    setSubmittingCancel(true);
    await cancelInitialSend();
    setSubmittingCancel(false);
  }

  return (
    <>
      <RoiTestSummary campaign={campaign} />
      <Button
        disabled={submittingCancel}
        variant="contained"
        onClick={handleCancel}
        sx={{ marginTop: theme.spacing(1), width: "250px" }}
      >
        {submittingCancel ? "Cancelling..." : "Cancel Scheduled Send"}
      </Button>
    </>
  );
}
